import React from "react";
import classNames from "classnames";
import { RequestStatus } from "../../../../types/mydata";
import { Typography } from "../../../../components/__common/Typography/Typography";

interface StepsProps {
  status: RequestStatus;
}

export const Steps: React.FC<StepsProps> = (props) => {
  const { status } = props;
  const allowedStatuses = [
    RequestStatus.COMPLETED,
    RequestStatus.PROCESSING,
    RequestStatus.REQUESTING,
    RequestStatus.QUEUED,
  ];

  // QUEUED represents "Requested" stage (also used for FAILED which is mapped to QUEUED)
  const stepOneValue = status === RequestStatus.QUEUED ? 1 : "";

  const stepTwoValue = status === RequestStatus.PROCESSING ? 2 : "";
  const stepThreeValue = status === RequestStatus.COMPLETED ? 3 : "";

  return (
    <>
      {allowedStatuses.includes(status) && (
        <div className="request-details__steps">
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.QUEUED,
              prev: status !== RequestStatus.QUEUED,
            })}
          >
            {stepOneValue}
          </Typography>

          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.PROCESSING,
              prev: status === RequestStatus.COMPLETED,
            })}
          >
            {stepTwoValue}
          </Typography>
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.COMPLETED,
            })}
          >
            {stepThreeValue}
          </Typography>
        </div>
      )}
    </>
  );
};
